import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode, isDevMode } from '@angular/core';
import { environment } from './environments/environment';

if (isDevMode()) {
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions) {
    if ((type === 'wheel' || type === 'touchmove') && (
      (this as any).classList?.contains?.('apexcharts-canvas') ||
      (this as any).classList?.contains?.('apexcharts-svg') ||
      (this as any).classList?.contains?.('apexcharts-tooltip') ||
      (this as any).id?.includes?.('chart')
    )) {
      if (typeof options === 'object') {
        options.passive = false;
      }
    }
    return originalAddEventListener.call(this, type, listener, options);
  };

  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const originalConsoleLog = console.log;
  const originalConsoleGroup = console.group;
  const originalConsoleGroupCollapsed = console.groupCollapsed;
  const originalConsoleTrace = console.trace;
  
  const shouldSuppressMessage = (msg: any): boolean => {
    const str = (msg?.toString?.() || msg || '').toString().toLowerCase();
    if (/\b(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS)\b.*\s(4\d{2}|5\d{2})\s/.test(str)) {
      return true;
    }
    if (/\b(500|501|502|503|504|400|401|403|404|429)\b/.test(str)) {
      return true;
    }
    if (str.includes('httperrorresponse') || str.includes('internal server error')) {
      return true;
    }
    if (str.includes('.azurewebsites.net') || str.includes('nox-be')) {
      return true;
    }
    if (str.includes('unable to preventdefault inside passive event listener') || 
        str.includes('preventdefault') && str.includes('passive')) {
      return true;
    }
    return false;
  };
  
  console.error = (...args: any[]) => {
    if (args.some(arg => arg?.status !== undefined && arg?.url !== undefined)) {
      return;
    }
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    const firstArg = args[0];
    if (typeof firstArg === 'string' && shouldSuppressMessage(firstArg)) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
  
  console.warn = (...args: any[]) => {
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    const firstArg = args[0];
    if (typeof firstArg === 'string' && shouldSuppressMessage(firstArg)) {
      return;
    }
    originalConsoleWarn.apply(console, args);
  };
  
  console.log = (...args: any[]) => {
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    originalConsoleLog.apply(console, args);
  };
  
  console.group = (...args: any[]) => {
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    return originalConsoleGroup.apply(console, args);
  };
  
  console.groupCollapsed = (...args: any[]) => {
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    return originalConsoleGroupCollapsed.apply(console, args);
  };
  
  console.trace = (...args: any[]) => {
    if (args.some(shouldSuppressMessage)) {
      return;
    }
    return originalConsoleTrace.apply(console, args);
  };
}


if (environment.production) {
 enableProdMode();
}

bootstrapApplication(AppComponent, {
 ...appConfig,
}).catch(err => console.error(err));
